export enum MatchType {
  EXACT = "exact",
  PARTIAL = "partial",
  REGEX = "regex",
}

export interface BlacklistPattern {
  pattern: string
  matchType: MatchType
}

export interface PatternMatchDetails {
  matchedText?: string
  index?: number
  groups?: string[]
}
